import { BasicCacheBreakerSwf, EnvGlobalsHandler } from "@goodgamestudios/core";

import { Poker2Environment } from "./config/Poker2Environment";

import { Poker2EnvironmentGlobals } from "./Poker2EnvironmentGlobals";

import { appVersion } from "./version/PokerGameVersion";

import { wrapper } from "./startup/Wrapper";

export class PokerCacheBreakerSwf extends BasicCacheBreakerSwf {
    constructor() {
        CONSTRUCTOR_HACK;
        EnvGlobalsHandler.setEnvGlobalsClass(new Poker2EnvironmentGlobals());
        super();
    }

    protected get customEnvironments(): any[] {
        return [Poker2Environment];
    }
}

wrapper(appVersion);

window.setLoadingScreenProgress(30);
new PokerCacheBreakerSwf();
